// GalleryPopup.js
import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import SwipeableViews from 'react-swipeable-views';
import './GalleryPopup.css';

const GalleryPopup = ({ images, selectedIndex, onClose, filteredStockItems, selectedCategory }) => {
  const [selectedImageIndex, setSelectedImageIndex] = useState(selectedIndex);

  const handlePrev = useCallback(() => {
    setSelectedImageIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : images.length - 1));
  }, [images]);

  const handleNext = useCallback(() => {
    setSelectedImageIndex((prevIndex) => (prevIndex < images.length - 1 ? prevIndex + 1 : 0));
  }, [images]);


  const handleKeyDown = useCallback((event) => {
    if (event.key === 'ArrowLeft') {
      handlePrev();
    } else if (event.key === 'ArrowRight') {
      handleNext();
    } else if (event.key === 'Escape') {
      onClose();
    }
  }, [handlePrev, handleNext, onClose]);

  useEffect(() => {
    document.body.style.overflow = 'hidden';

    const handleKeyDownWrapper = (event) => {
      handleKeyDown(event);
    };

    // Add event listener for keydown
    window.addEventListener('keydown', handleKeyDownWrapper);

    return () => {
      document.body.style.overflow = 'auto';

      // Remove event listener when component unmounts
      window.removeEventListener('keydown', handleKeyDownWrapper);
    };
  }, [selectedImageIndex, handleKeyDown, onClose]); // Include handleKeyDown in the dependency array

  return (
    <div className="gallery-popup">
      <button onClick={onClose}>
        <img src="/data/photos/logo/closew.png" alt="close" />
      </button>
      <div className="gallery-images">
      <SwipeableViews index={selectedImageIndex} onChangeIndex={setSelectedImageIndex} enableMouseEvents >
        {images.map((image, index) => (
          <div key={index}>
            <img src={image.image} alt={`Image ${index}`} />
          </div>
        ))}
      </SwipeableViews>
      </div>
      <div onClick={handlePrev} className="prev"></div>
      <div onClick={handlePrev} className="prev-i">
        ❰
      </div>
      <div onClick={handleNext} className="next"></div>
      <div onClick={handleNext} className="next-i">
        ❱
      </div>
        {filteredStockItems[selectedImageIndex].gallery?.length > 0 ? (
          <Link to={`/Nabytok/${selectedCategory}/${filteredStockItems[selectedImageIndex].title}`}>
            {filteredStockItems[selectedImageIndex].title}
          </Link>
        ) : (
          <h1>{filteredStockItems[selectedImageIndex].title}</h1>
        )}
    </div>
  );
};

export default GalleryPopup;
